module.exports = __webpack_public_path__ + "img/brand (36).fee3a6a2.png";